module.exports = __webpack_public_path__ + "static/media/exposedPassword.9b5ad1a9.svg";